module.exports = __webpack_public_path__ + "static/google-play-store-5743b0939a6c421d919fe1ab84acad4c.jpg";